module.exports = __webpack_public_path__ + "static/media/telegram (1).9d5e4648.png";